import moment from "moment"
import { BASE_URL } from "../Config"

const baseRoute = (name = '') => {
    return `${process.env.REACT_APP_DOMAIN_DIR}/${name}`
}

const apiBaseUrl = () => {
    return BASE_URL + 'api/'
}

const sessionStorageToken = () => {
    return process.env.REACT_APP_TOKEN;
}

export { baseRoute, apiBaseUrl, sessionStorageToken } 

export const formatTime = (time) => {
    return moment(time).format("LT");
  };
  
  export const getTime = (timestamp) => {
    if (!moment(timestamp).isValid()) return "";
    return moment(timestamp).fromNow();
  };
  
  export const formatDate = (date) => {
    return moment(date).format("DD-MM-yyyy");
  };
  
  export const formatDateMonth = (date) => {
    return moment(date).format("ll");
  };
